import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const getContractQueryKey = (uuid: string) =>
  [`${API_ENDPOINTS.CONTRACTS}/${uuid}`] as const

const params = (uuid: string) => ({
  queryKey: getContractQueryKey(uuid),
  queryFn: () => get(`${API_ENDPOINTS.CONTRACTS}/${uuid}`, contractSchema),
})

export const useAPIGetContract = (uuid: string) => useQuery(params(uuid))

export const useAPIGetContractSuspense = (uuid: string) =>
  useSuspenseQuery(params(uuid))
